import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d3c24aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "tw-text-center tw-mt-20 md:tw-mt-0"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "tw-text-2xl tw-tracking-[0.15px] tw-leading-6 tw-font-bold tw-text-[#0C0F4A] md:tw-text-xl" }, " Pay Deposit ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-text-sm tw-tracking-[0.4px] tw-leading-5 tw-font-normal tw-text-[#0C0F4A] tw-mt-5 md:tw-text-xs tw-max-w-[82%] tw-m-auto md:tw-max-w-full" }, " Deposing funds enables the trade contractor to start working on your project. Be sure the estimate reflects the work you need completed before paying your deposit. ", -1))
const _hoisted_4 = { class: "confirm_amount tw-mt-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-text-sm tw-tracking-[0.4px] tw-leading-5 tw-font-bold tw-text-[#0c0f4a80]" }, " Deposit amount ", -1))
const _hoisted_6 = { class: "tw-text-[38px] tw-tracking-[0.25px] tw-leading-10 tw-font-bold tw-text-[#0c0f4a] md:tw-text-3xl" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-tracking-[0.4px] tw-leading-5 tw-font-normal tw-text-[#0c0f4a80] tw-mt-7 tw-max-w-[82%] tw-m-auto md:tw-max-w-full" }, [
  /*#__PURE__*/_createTextVNode(" By confirming you are agreeing to our "),
  /*#__PURE__*/_createElementVNode("strong", { class: "tw-text-[#0c0f4a]" }, " Terms & Conditions "),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("strong", { class: "tw-text-[#0c0f4a]" }, " Privacy Policy.")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-tracking-[0.4px] tw-leading-5 tw-font-normal tw-text-[#0c0f4a80] tw-mt-7 tw-max-w-[86%] tw-m-auto md:tw-max-w-full" }, [
  /*#__PURE__*/_createTextVNode(" Additionally, by confirming you are permitting our partner Modulr FS Limited to initiate a payment from your bank account and also agree to their "),
  /*#__PURE__*/_createElementVNode("strong", { class: "tw-text-[#0c0f4a]" }, "Terms & Conditions"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("strong", { class: "tw-text-[#0c0f4a]" }, "Privacy Policy")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "tw-w-full tw-grid tw-grid-cols-2 tw-items-center tw-gap-3 tw-mt-6"
}

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import CurrencyFilter from "@/filters/currency.filter";
import { ref } from "vue";
import CommonLoader from "@/core/components/CommonLoader.vue";
import tradeEstimateService from "@/core/services/trade-estimate.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'PayDepositModal',
  props: {
  totalPayAmount: {
    type: Number,
  },
  paymentPayload: {
    type: Object,
  },
},
  emits: ["on-close", "on-confirm"],
  setup(__props, { emit: __emit }) {

const props = __props;
const loading = ref(false);
const formattedCurrency = (value: any) => {
  return CurrencyFilter.formatToCurrency(value);
};
const emits = __emit;
const onCloseModal = () => {
  emits("on-close");
};

const onConfirm = async () => {
  try {
    loading.value = true;
    const response = await tradeEstimateService.createPayDeposit(
      props?.paymentPayload
    );

    if (response) {
      let a = document.createElement("a");
      a.href = response?.redirectUrl;
      a.click();
      emits("on-confirm");
    }
  } catch (error) {
    console.log("error", error);
    emits("on-confirm");
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "tw-w-[500px] tw-max-w-full md:tw-w-[340px]",
    onOnClose: onCloseModal,
    width: "500px",
    "max-width": "100%"
  }, {
    body: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createBlock(CommonLoader, {
            key: 0,
            loading: loading.value,
            class: "loader-container"
          }, null, 8, ["loading"]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("h4", _hoisted_6, _toDisplayString(formattedCurrency(__props.totalPayAmount)), 1)
            ]),
            _hoisted_7,
            _hoisted_8
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(Button, {
              variant: "tertiary",
              disabled: loading.value,
              label: "Cancel",
              onClick: onCloseModal,
              class: "button button-purple-border"
            }, null, 8, ["disabled"]),
            _createVNode(Button, {
              variant: "tertiary",
              label: "Confirm",
              isLoading: loading.value,
              onClick: onConfirm,
              class: "button button-orange"
            }, null, 8, ["isLoading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})